<template>
    <div class="ChildList" style="display:flex;flex-direction:column; max-height:85vh;">
        <h2>Residential Children Enrollments <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /></h2>
        <div class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Child Status:</label>
                        <select class="form-control" v-model="Filters.Status" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option value="Active">Active</option>
                            <option value="Open MH">Open MH Case</option>
                            <option value="Discharged MH">Discharged MH Case</option>
                            <option value="Terminated">Terminated</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Program:</label>
                        <select class="form-control" v-model="Filters.SubProgramID" @change="RefreshDataTable">
                            <option v-if="CheckPermission('CanAccessAllOptionInSubPrograms')" value="">All</option>
                            <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>House:</label>
                        <select class="form-control" v-model="Filters.ResidenceID" @change="RefreshDataTable">
                            <option value="">All</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    Displaying {{NumberOfClients}} Records
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Clients:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow:auto">
            <vuetable :fields="ChildrenTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      id="childrendatatableid">

                <template slot="ChildRecordLinkFirst" scope="props">
                    <div class="ChildRecordLinkFirst">
                        <span class="underline pointer" @click="OpenChildRecord(props.rowData.ClientProgramMembership.Id, props.rowData)" v-html="props.rowData.Person.AKA ? props.rowData.Person.FirstName + ' &quot;' + props.rowData.Person.AKA + '&quot;' : props.rowData.Person.FirstName"></span>
                    </div>
                </template>
                <template slot="ChildRecordLinkLast" scope="props">
                    <div class="ChildRecordLinkLast">
                        <span class="underline pointer" @click="OpenChildRecord(props.rowData.ClientProgramMembership.Id, props.rowData)" v-html="props.rowData.Person.LastName"></span>
                    </div>
                </template>
                <template slot="LastNameFirstInitial" scope="props">
                    <div class="LastNameFirstInitial">
                        <span class="underline pointer" @click="OpenChildRecord(props.rowData.ClientProgramMembership.Id, props.rowData)" v-html="props.rowData.Person.LastNameFirstInitial"></span>
                    </div>
                </template>
                <!--<template slot="DetailButton" scope="props">
                    <div class="pointer" @click="onCellClicked(props.rowData)">
                        <span class="underline pointer"> <font-awesome-icon :icon="['fa', 'caret-down']" class="pointer" /></span>
                    </div>
                </template>-->
            </vuetable>
        </div>
    </div>
</template>

<script>
    //import services
    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../services/event-bus.js';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faCaretDown);

    export default {
        created() {
            this.$store.commit("Clients.ClientProfiles.Clear");
            this.$store.commit("Clients.ClientEnrollmentsList.Clear");
        },
        props: [],
        data: function () {
            return {
                NumberOfClients: '',
                search: "",
                Filters: {
                    Status: "Active",
                    SubProgramID: "",
                    ResidenceID: ""
                },
                ChildrenTableOptions: {
                    Fields: [
                        {
                            name: '__slot:LastNameFirstInitial',
                            title: 'Name',
                            sortField: 'Person.LastNameFirstInitial',
                            //width: "15%"
                        },
                        {
                            name: '__slot:ChildRecordLinkLast',
                            title: 'Last',
                            sortField: 'Person.LastName',
                            //width: "15%"
                        },
                        {
                            name: 'Person.LastName',
                            title: 'Last',
                            visible: false
                        },
                        {
                            name: '__slot:ChildRecordLinkFirst',
                            title: 'First',
                            sortField: 'Person.FirstName',
                            //width: "15%"
                        },
                        {
                            name: 'Person.FirstName',
                            title: 'First',
                            visible: false
                        },
                        {
                            name: 'CID',
                            title: 'CID',
                            visible: false
                        },
                        {
                            name: 'GradeLevel',
                            title: 'Level',
                            sortField: 'GradeLevel',
                            //width: "15%"
                        },
                        {
                            name: 'Person.DOB',
                            title: "DOB",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'Person.DOB',
                            //width: "15%"
                        },
                        {
                            name: 'Person.AgeString',
                            title: "Age",
                            dataClass: 'td-nowrap',
                            sortField: 'Person.DOB',
                            //width: "15%"
                        },
                        {
                            name: 'SubProgramStartDate',
                            title: "Start Date",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'SubProgramStartDate',
                            //width: "15%"
                        },
                        {
                            name: 'SubProgramEndDate',
                            title: "Term Date",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'SubProgramEndDate',
                            //width: "15%"
                        },
                        {
                            name: 'ResidenceName',
                            title: "House",
                            sortField: 'ResidenceName',
                            //width: "10%"
                        },
                        {
                            name: 'PlacementCountyName',
                            title: "County",
                            sortField: 'PlacementCountyName',
                            //width: "15%"
                        },
                        //{
                        //    name: '__slot:DetailButton',
                        //    title: 'More Details',
                        //    dataClass: 'd-xl-none',
                        //    titleClass: 'd-xl-none',
                        //    //width: "5%"
                        //},
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetChildren();
                
            },
            GetChildren() {
                var vm = this;
                let openRecords = [];
                Object.keys(this.$store.state.Clients.ClientProfiles).map(function (key, index) {
                    openRecords.push(vm.$store.state.Clients.ClientProfiles[key].ClientProgramMembership.Id)
                });
                this.$MasterAPI.ExecuteRequest("POST", "Residential/Clients/GetClients", { ...this.Filters, ExistingRecords: openRecords }, this.GetChildrenSuccess, () => { }, false);
            },
            GetChildrenSuccess(response) {
                let filteredArray = response.data.data.filter(function( obj ) {
                    return obj.Show !== false;
                });
                this.$store.commit("Clients.ClientEnrollmentsList.Replace", filteredArray);
                this.$refs.datatable.refresh();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenChildRecord(subProgramMembershipID, childRecordData) {
                this.$store.commit("Clients.ClientProfiles.Append", childRecordData);

                this.$parent.ChangePaneShown(subProgramMembershipID);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.$store.state.Clients.ClientEnrollmentsList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                        
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfClients = visibleData.length;
                return visibleData;                  
            }
        },
        components: {
            Vuetable
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            var vm = this;
            //SET FILTER IF PRIVATE PROFILE = MH PRIMARY
            if (this.$store.getters["User.PrivateProfile.GetPrimarySpecifier"]() == "MH PRIMARY") {
                this.Filters.Status = "Open MH";
            }
            //Get Child Records*/
            this.GetChildren();
            let getchildrenFunc = function () {
                vm.GetChildren();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getchildrenFunc);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>